<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
      <v-btn
        color="primary"
        class="ms-2"
        @click="newItem()"
      >
        <i class="fas fa-layer-plus fa-lg me-2" />
        {{ $t('new') }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn
          fab
          x-small
          depressed
          class="me-2 blue"
          @click="showItem(item)"
        >
          <i
            class="fal fa-eye fa-lg"
          />
        </v-btn>
        <v-btn
          fab
          x-small
          depressed
          class="me-2 warning"
          @click="editItem(item)"
        >
          <i
            class="fal fa-pencil fa-lg"
          />
        </v-btn>
        <v-btn
          fab
          x-small
          depressed
          class="me-2 error"
          @click="deleteConfirm(item)"
        >
          <i
            class="fal fa-trash-alt fa-lg"
          />
        </v-btn>
      </template>
      <template v-slot:item.status_text="{ item }">
        <v-chip
          :color="getStatusColor(item.status_text)"
        >
          {{ $t(item.status_text) }}
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      :internal-activator="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >
            {{ formTitle }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="10"
              >
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('title')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                >
                <template
                  v-slot:prepend
                >
                  <span class="mt-1 me-2">{{ $t('status') }}</span>
                </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
              >
                <span>{{ $t('description') }}</span>

<!--                <ckeditor-->
<!--                  :editor="editor"-->
<!--                  v-model="editedItem.description"-->
<!--                  :config="editorConfig"-->
<!--                />-->
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShow"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="4"
                sm="9"
                md="10"
              >
                <p>{{ $t('id') }} : <strong>{{ editedItem.id }}</strong></p>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                  disabled
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2 text-no-wrap">{{ $t('status') + ` : ` + $t(editedItem.status_text) }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('title') }} : <strong>{{ editedItem.title }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('description') }} : </p>
                <ckeditor
                  :editor="editor"
                  v-model="editedItem.description"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('created_at') }} : <strong>{{ editedItem.created_at }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('updated_at') }} : <strong>{{ editedItem.updated_at }}</strong></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleteItem(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  // import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  export default {
    name: 'Operations',
    data () {
      return {
        headers: [],
        dataRows: [],
        categoryRows: [],
        dynamicColumns: [],
        tableCPP: 0,
        search: '',
        loading: true,
        dialog: false,
        dialogShow: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        formTitle: '',
        deleteSheet: false,
        btnLoadingDelete: false,
        btnLoadingSave: false,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
        // editor: ClassicEditor,
        // editorConfig: {
        //   language: {
        //     ui: 'en',
        //     content: 'fa',
        //   },
        //   toolbar: [
        //     'undo',
        //     'redo',
        //     'fontColor',
        //     'fontBackgroundColor',
        //     'fontSize',
        //     '|',
        //     'bold',
        //     'italic',
        //     'underline',
        //     'removeFormat',
        //     'alignment',
        //     'bulletedList',
        //     'numberedList',
        //     'horizontalLine',
        //     '|',
        //     'link',
        //     'imageUpload',
        //     'insertTable',
        //     'mediaEmbed',
        //   ],
        //   image: {
        //     toolbar: [
        //       'imageTextAlternative',
        //       'imageStyle:full',
        //       'imageStyle:side',
        //     ],
        //   },
        //   table: {
        //     contentToolbar: [
        //       'tableColumn',
        //       'tableRow',
        //       'mergeTableCells',
        //     ],
        //   },
        // },
      }
    },
    async created () {
      await this.getData()
      await this.getOptions()
      await this.getHeaders()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showByTitle', {
          title: 'Pages-CPP',
        }).then(
          response => {
            const result = response.data.Option
            this.tableCPP = parseInt(result.value)
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/showByTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showByTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getHeaders () {
        this.$http.post('options/showTableHeader', {
          title: 'Pages-TH-Operations',
        }).then(
          response => {
            const result = response.data.Option
            this.headers = []
            this.headers.push({ text: this.$t('id'), value: 'id' })
            result.forEach(o => {
              this.headers.push({
                text: this.$t(o.value),
                value: o.value,
              })
            })
            this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/showTableHeader|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showTableHeader|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getData () {
        this.$http.post('pages/index').then(
          response => {
            this.dataRows = response.data.Pages
            this.editedItem = Object.assign({}, this.dataRows[0])
            const tempArray = []
            Object.keys(this.editedItem).forEach(function (item) {
              Object.assign(tempArray, { [item]: null })
            })
            this.defaultItem = tempArray
            this.loading = false
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': pages/index|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': pages/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      newItem () {
        this.formTitle = this.$t('new')
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = true
      },
      editItem (item) {
        this.formTitle = this.$t('edit')
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteConfirm (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogShow = true
      },
      deleteItem (item) {
        this.btnLoadingDelete = true
        this.$http.post('pages/delete', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': pages/delete|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': pages/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoadingSave = true
        if (this.editedIndex > -1) {
          this.$http.post('pages/update', this.editedItem).then(
            response => {
              Object.assign(this.dataRows[this.editedIndex], this.editedItem)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
              this.close()
            },
            error => {
              this.btnLoadingSave = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': pages/update|901'
              this.snackbar = true
              console.log(error)
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': pages/update|902'
            this.snackbar = true
            console.log(error)
          })
        } else {
          this.editedItem.language_id = 1
          this.$http.post('pages/create', this.editedItem).then(
            response => {
              this.dataRows.push(response.data.Page)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
              this.close()
            },
            error => {
              this.btnLoadingSave = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': pages/create|901'
              this.snackbar = true
              console.log(error)
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': pages/create|902'
            this.snackbar = true
            console.log(error)
          })
        }
      },
      close () {
        this.dialog = false
        this.dialogShow = false
        this.editedIndex = -1
      },
      getStatusColor (text) {
        let returnColor
        switch (text) {
          case 'deactivate':
            returnColor = 'red'
            break
          case 'active':
            returnColor = 'green'
            break
          case 'locked':
            returnColor = 'purple'
            break
          case 'unknown':
            returnColor = 'yellow'
            break
          default:
            returnColor = 'yellow'
        }
        return returnColor
      },
    },
  }
</script>

<style scoped>

</style>
